import { Box, Theme } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import { Paper } from "@mui/material";
import { getBrandCustom } from "../../util/getCustomColor";

// #region - Palette
export const primaryColor = getBrandCustom("primaryColor", "#38CFC4");
export const successColor = "#308CD";
export const successColorA = "#12B76A";
export const successColorB = "#A6F4C5";
export const successColorC = "#DDF4F3";
export const successColorD = "#D1E9FF";
export const successColorE = "#1570EF";

export const infoColor = "#F1D247";
export const infoColorA = "#363F72";
export const errorColor = "#CF4842";
export const errorColorA = "#FECDCA";
export const errorColorB = "#F97066";
export const errorColorC = "#B32318";
export const errorColorD = "#FFEAD5";
export const errorColorE = "#EC4A0A";

export const brandSuccessColor = "#308CDB";
export const boxDefaultBG = "#EDF5FB";
export const boxDefaultBorder = "#308CDB";
export const boxBGColorA = "#F0F6FA";

export const strongGray = "#465869";
export const lightGray = "#EDF5FB";
export const lighestGray = "#F8FAFC";
export const flatGray = "#C4C4C4";
export const gray1 = "#93A9BD";
export const gray2 = "#CCDEEE";
export const gray3 = "#D0D5DD";

export const blue1 = "#20639D";
export const blue2 = "#3F6280";
export const white = "#FFFFFF";
export const black = "#000000";
export const purple = "#8683F6";
export const purpleA = "#B692F6";
export const purpleB = "#E0EAFF";
export const purpleC = "#444CE7";
export const orange = "#8683F6";
export const errorBorder = "#8E2D29";

export const textColor = "#465869";
export const placeholderColor = "#9CA6AF";

export const disabledA = "#C4C4C4";
export const disabledB = "#DEDEDE";
export const disabledC = "#B7B7B7";

export const textGrayH1 = "#667085";

export const defPageBGColor = "#E5E5E5";
export const pprBorderColorA = "#E4E7EC";
export const pprBorderColorB = "#F2F4F7";

export const textSuccessA = "#32D583";
export const textSuccessB = "#12B76A";

export const textInfoA = "#0BA5EC";
export const textInfoB = "#2E65F3";
export const textInfoC = "#DCECFB";
export const textInfoD = "#0086C9";
export const textInfoE = "#369CF3";

export const textWarnA = "#FB6514";
export const textWarnB = "#FEB273";
export const textWarnC = "#FDB022";
export const textWarnD = "#DC6803";
export const textWarnE = "#FEF0C7";

export const textGrayA = "#93A9BD";
export const textGrayB = "#344054";
export const textGrayC = "#465869";

export const toolbarBG1 = "#FCFCFD";

// #endregion

// #region - Override Wrappers
// Custom::: Box - Wrapper SubComponent
export const BxWrap = withStyles(() =>
  createStyles({
    root: {
      display: "flex",
      border: "1px solid #93A9BD",
      borderRadius: 5,
      minWidth: 200,
      height: 38,
      background: "#EDF5FB",
      padding: 10,
    },
  })
)(Box);

// Custom::: Paper - Dash Filter Wrap
export const DashFilterWrap = withStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 40,
      display: "flex",
      alignItems: "center",
      border: `1px solid ${pprBorderColorA}`,
      borderRadius: `8px !important`,
      marginRight: 10,
      boxShadow: "none !important",
      "& .MuiButton-root": {
        padding: 8,
        textTransform: "none",

        "& .MuiButton-label": {
          fontWeight: 500,
          fontSize: 14,
          color: strongGray,
        },
      },
      "& span": {
        color: strongGray,
        fontWeight: 500,
        fontSize: 14,
      },
      "& .lbl-filter": {
        marginLeft: 10,
        marginRight: 10,
        [theme.breakpoints.down("md")]: {
          display: "none",
        },
      },
      "& .bx-filter": {
        display: "flex",
        width: 150,
        fontFamily: "Manrope",
        "& .btn-option": {
          height: 21,
        },
        "& .MuiIconButton-root": {
          height: 21,
          width: 21,
        },
        "& .MuiButton-root": {
          fontFamily: "Manrope",
          color: strongGray,
          textTransform: "none",
          fontWeight: 500,
          fontSize: 14,
          justifyContent: "flex-start",
          "& .MuiButton-endIcon": { width: "100%" },
        },
      },
      "& .filter-proj": {
        minWidth: "244px  !important",
        fontFamily: "Manrope",
        "& span": {
          width: "100%",
          textAlign: "left",
          fontWeight: 500,
          fontSize: 14,
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        },
        "& .MuiButton-endIcon": { width: "auto" },
      },
    },
  })
)(Paper);

// #endregion

// #region - DashPage Default Styling
export const useStyles = makeStyles((theme: Theme) => ({
  rootBox: {
    padding: "16px 32px",
    "& p, h1, h2, h4, h5, span, th, tr, td, .MuiTypography-root": {
      fontFamily: "Manrope",
    },
    "& .st-counts-widgets": {
      [theme.breakpoints.down("md")]: {
        flexDirection: "column-reverse",
      },
    },
  },
  bxTitleHeader: {
    background: lighestGray,
    minHeight: 64,
    display: "flex",
    boxShadow: `inset 0px -1px 0px #F0F0F0`,
  },
  titleHeader: {
    fontWeight: 700,
    color: primaryColor,
    fontSize: `24px !important`,
    display: "block",
    margin: "20px 25px",
    fontFamily: "Manrope",
    "& span": {
      fontWeight: 800,
      fontSize: 24,
      color: textGrayH1,
    },
  },
  tlbHeader: {
    gap: 8,
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column !important",
    },
    "& .divider": {
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
      width: 1,
      height: 30,
      margin: "auto 20px",
      background: "#93A9BD",
    },
  },
  widgetCountWrap: {
    height: "auto",
    paddingRight: 8,
    paddingLeft: 8,
    border: `1px solid ${pprBorderColorA}`,
    borderRadius: `12px !important`,
    boxShadow: "none !important",
    "& .divider": {
      width: 1,
      background: pprBorderColorB,
      height: 110,
      margin: "auto 2px",
    },
    "@media (max-width: 480px)": {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  widgetWrapper: {
    "@media (max-width: 1279px)": {
      alignItems: "start !important",
    },
  },
  filterWrap: {
    marginBottom: 10,
    "& .lblFilter": {
      marginBottom: 10,
      color: brandSuccessColor,
      fontSize: 14,
      fontWeight: 600,
    },
  },
  inputDateRange: {
    marginRight: "7px",
  },
  buttonSpace: {
    padding: "0px 20px",
    fontWeight: 700,
    fontSize: "13px",
  },
}));

// #endregion
